// ----------------------------------------------------------------------------
// Section: Featured Collection
// ----------------------------------------------------------------------------
//
// This is a section that displays featured collection items and optional button
//
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------
import $ from 'jquery';
import Swiper, { Navigation, A11y } from 'swiper';
import 'snippets/card/card';
import 'snippets/icon/icon';

// Style includes
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/a11y';
import './_featured-products.scss';



// -------------------------------------
// Variables
// -------------------------------------

// -------------------------------------
// Hooks
// -------------------------------------

function handleSlides(swiperEl) {
    swiperEl.slides.forEach(function(slide, index) {
        let slideLink = slide.querySelector('a');
        slideLink.addEventListener('focus', function(e) {
            swiperEl.slideTo(index);
        })
    });
}

$(function() {
    $(".carousel--featured-products").each(function(index, element){
    var $this = $(this);

    // Generate unique class for each feature collection slider
    $this.addClass("featured-products-instance-" + index);

    // Generate unique btn classes for slider arrows
    $this.parents('.featured-products').find(".swiper-button-prev").addClass("featured-products-btn-prev-" + index);
    $this.parents('.featured-products').find(".swiper-button-next").addClass("featured-products-btn-next-" + index);

    // Initialize feature collection slider based on the unique classes generated above.
    var swiper = new Swiper(".featured-products-instance-" + index, {
        // Optional parameters
        modules: [Navigation, A11y],
        slidesPerView: 50,
        autoResize: false,
        visibilityFullFit: true,
        observer: true,
        observeParents: true,
        a11y: false,
        watchOverflow: true, // Do not turn into sliders if number of slides is less than slidesPerView.

        breakpoints: {
          // when window width is >= 680px
          680: {
            slidesPerView: 4,
            spaceBetween: 60
          }
        },

        // // Navigation arrows
        navigation: {
          nextEl: ".featured-products-btn-next-" + index,
          prevEl: ".featured-products-btn-prev-" + index
        }
    });

    swiper.slides.forEach(function(slide, index) {
        let slideLink = slide.querySelector('a');
        slideLink.addEventListener('focus', function(e) {
            swiper.slideTo(index);
        })
    });
  });
});

if (document.querySelector('.carousel--featured-products') !== null) {

    var slides = document.querySelectorAll('.swiper-wrapper .swiper-slide');
    var arrowPrev = document.querySelector('.swiper-button-prev');
    var arrowNext = document.querySelector('.swiper-button-next');

    if (slides.length < 4) {
        arrowPrev.style.display = 'none';
        arrowNext.style.display = 'none';
    }

      // Optimalisation: Store the references outside the event handler:
      var $window = $(window);

      function checkWidth() {
          var windowsize = $window.width();
          if (windowsize < 680) {
                $('.carousel--featured-products .swiper-slide').addClass('full');
            } else {
                $('.carousel--featured-products .swiper-slide').removeClass('full');
            }
      }
      // Execute on load
      checkWidth();
      // Bind event listener
      $(window).resize(checkWidth);

}

